import httpClient, {
  FormMultiPart,
  FormUrlEncoded,
  ApplicationJson,
  POST,
  PUT,
  GET,
  DELETE,
} from '@/apis/base/httpclient';
import commonFn from '@/commons/commonFunction';

export default class BaseAPI {
  baseUrl = '';
  controllerName = '';
  apiName = '';

  //khởi tạo ApiUrl
  // created by NDQUAN 20/08/2019
  //API được khởi tạo dựa trên apiName
  initAPI() {
    if (this.apiName) {
      this.baseUrl = window._apis[this.apiName] + '/' + this.controllerName;
    }
  }

  //Build api url
  //CreatedBy NDQUAN 20/08/2019
  getAPIUrl() {
    // Khi base url chưa khởi tạo
    if (this.baseUrl == '') {
      this.initAPI();
    }
    //Nếu có truyền thêm argument thì nó khởi tạo thêm url
    if (arguments && arguments.length > 0) {
      return commonFn.combineUrl(this.baseUrl, ...arguments);
    }

    return this.baseUrl;
  }

  /**
   * config: AxiosRequestConfig
   * @param config: {
   * url?: string;
   * method?: string;
   * baseURL?: string;
   * transformRequest?: AxiosTransformer | AxiosTransformer[];
   * transformResponse?: AxiosTransformer | AxiosTransformer[];
   * headers?: any;
   * params?: any;
   * paramsSerializer?: (params: any) => string;
   * data?: any;
   * timeout?: number;
   * withCredentials?: boolean;
   * adapter?: AxiosAdapter;
   * auth?: AxiosBasicCredentials;
   * responseType?: string;
   * xsrfCookieName?: string;
   * xsrfHeaderName?: string;
   * onUploadProgress?: (progressEvent: any) => void;
   * onDownloadProgress?: (progressEvent: any) => void;
   * maxContentLength?: number;
   * validateStatus?: (status: number) => boolean;
   * maxRedirects?: number;
   * httpAgent?: any;
   * httpsAgent?: any;
   * proxy?: AxiosProxyConfig | false;
   * cancelToken?: CancelToken;
   * }
   * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
   * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
   * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
   */
  async postAsync(
    config,
    isShowLoading = false,
    isCancelRequest = true,
    contenType = ApplicationJson
  ) {
    return await httpClient.requestAsync(
      config,
      POST,
      isShowLoading,
      isCancelRequest,
      contenType
    );
  }

  /**
   * config: AxiosRequestConfig
   * @param config: {
   * url?: string;
   * method?: string;
   * baseURL?: string;
   * transformRequest?: AxiosTransformer | AxiosTransformer[];
   * transformResponse?: AxiosTransformer | AxiosTransformer[];
   * headers?: any;
   * params?: any;
   * paramsSerializer?: (params: any) => string;
   * data?: any;
   * timeout?: number;
   * withCredentials?: boolean;
   * adapter?: AxiosAdapter;
   * auth?: AxiosBasicCredentials;
   * responseType?: string;
   * xsrfCookieName?: string;
   * xsrfHeaderName?: string;
   * onUploadProgress?: (progressEvent: any) => void;
   * onDownloadProgress?: (progressEvent: any) => void;
   * maxContentLength?: number;
   * validateStatus?: (status: number) => boolean;
   * maxRedirects?: number;
   * httpAgent?: any;
   * httpsAgent?: any;
   * proxy?: AxiosProxyConfig | false;
   * cancelToken?: CancelToken;
   * }
   * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
   * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
   * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
   */
  async putAsync(
    config,
    isShowLoading = false,
    isCancelRequest = true,
    contenType = ApplicationJson
  ) {
    return await httpClient.requestAsync(
      config,
      PUT,
      isShowLoading,
      isCancelRequest,
      contenType
    );
  }

  /**
   * config: AxiosRequestConfig
   * @param config: {
   * url?: string;
   * method?: string;
   * baseURL?: string;
   * transformRequest?: AxiosTransformer | AxiosTransformer[];
   * transformResponse?: AxiosTransformer | AxiosTransformer[];
   * headers?: any;
   * params?: any;
   * paramsSerializer?: (params: any) => string;
   * data?: any;
   * timeout?: number;
   * withCredentials?: boolean;
   * adapter?: AxiosAdapter;
   * auth?: AxiosBasicCredentials;
   * responseType?: string;
   * xsrfCookieName?: string;
   * xsrfHeaderName?: string;
   * onUploadProgress?: (progressEvent: any) => void;
   * onDownloadProgress?: (progressEvent: any) => void;
   * maxContentLength?: number;
   * validateStatus?: (status: number) => boolean;
   * maxRedirects?: number;
   * httpAgent?: any;
   * httpsAgent?: any;
   * proxy?: AxiosProxyConfig | false;
   * cancelToken?: CancelToken;
   * }
   * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
   * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
   * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
   */
  async getAsync(
    config,
    isShowLoading = false,
    isCancelRequest = true,
    contenType = ApplicationJson
  ) {
    return await httpClient.requestAsync(
      config,
      GET,
      isShowLoading,
      isCancelRequest,
      contenType
    );
  }

  /**
   * config: AxiosRequestConfig
   * @param config: {
   * url?: string;
   * method?: string;
   * baseURL?: string;
   * transformRequest?: AxiosTransformer | AxiosTransformer[];
   * transformResponse?: AxiosTransformer | AxiosTransformer[];
   * headers?: any;
   * params?: any;
   * paramsSerializer?: (params: any) => string;
   * data?: any;
   * timeout?: number;
   * withCredentials?: boolean;
   * adapter?: AxiosAdapter;
   * auth?: AxiosBasicCredentials;
   * responseType?: string;
   * xsrfCookieName?: string;
   * xsrfHeaderName?: string;
   * onUploadProgress?: (progressEvent: any) => void;
   * onDownloadProgress?: (progressEvent: any) => void;
   * maxContentLength?: number;
   * validateStatus?: (status: number) => boolean;
   * maxRedirects?: number;
   * httpAgent?: any;
   * httpsAgent?: any;
   * proxy?: AxiosProxyConfig | false;
   * cancelToken?: CancelToken;
   * }
   * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
   * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
   * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
   */
  async deleteAsync(
    config,
    isShowLoading = false,
    isCancelRequest = true,
    contenType = ApplicationJson
  ) {
    return await httpClient.requestAsync(
      config,
      DELETE,
      isShowLoading,
      isCancelRequest,
      contenType
    );
  }

  /**
   * Lấy dữ liệu danh sách
   */
  getList(payload) {
    let request = {
      url: this.getAPIUrl() + '/list',
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy summary danh sách
   */
  getListSummary(payload) {
    let request = {
      url: this.getAPIUrl() + '/list-summary',
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu danh sách full
   */
  getFullList(payload) {
    let request = {
      url: this.getAPIUrl() + '/full',
      data: payload,
    };

    return httpClient.getAsync(request);
  }
  /**
   * Lấy dữ liệu danh sách tree
   */
  getTree(payload) {
    let request = {
      url: this.getAPIUrl() + '/tree',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu danh sách theo ids, ids là chuỗi phân cách bởi dấu ,
   * HTHIEP 13.07.2022
   */
  getDataByIds(payload) {
    let request = {
      url: this.getAPIUrl() + '/ids',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy bản ghi mặc định khi thêm mới
   */
  getNew(payload) {
    let request = {
      url: this.getAPIUrl() + '/new',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  getAutoID(payload) {
    let request = {
      url: this.getAPIUrl() + '/getAutoID',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy bản ghi mặc định khi thêm mới
   */
  getEdit(payload) {
    let request = {
      url: [this.getAPIUrl(), 'edit', payload.id].join('/'),
    };

    return httpClient.getAsync(request);
  }
  /**
   * Lấy bản ghi nhân bản
   */
  getDuplicate(payload) {
    let request = {
      url: this.getAPIUrl() + '/duplicate',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Thêm mới
   */
  insert(payload) {
    let request = {
      url: this.getAPIUrl(),
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }

  /**
   * Thêm mới
   */
  insertMulti(payload) {
    let request = {
      url: this.getAPIUrl() + '/batch',
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }

  /**
   * Cập nhật
   */
  update(payload) {
    let request = {
      url: this.getAPIUrl(),
      data: payload,
    };
    return httpClient.putAsync(request, true);
  }

  /**
   * Xóa
   */
  delete(payload) {
    let request = {
      url: this.getAPIUrl(),
      data: payload,
    };
    return httpClient.deleteAsync(request, true);
  }

  /**
   * Xóa chứng từ liên quan
   * NXCHIEN 19.07.2022
   */
  deleteRelation(payload) {
    let request = {
      url: this.getAPIUrl() + '/DeleteRelation',
      data: payload,
    };
    return httpClient.deleteAsync(request, true);
  }

  /**
   * Lấy dữ liệu combobox load paging
   */
  getComboboxPaging(payload) {
    let param = { ...payload };

    //xử lý tham số trước khi request load dữ liệu
    commonFn.processComboboxParamRequest(param);

    let request = {
      url: this.getAPIUrl() + '/combobox',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Chuyển dữ liệu dữu liệu danh mục
   */
  UpdateTranferData(payload) {
    let request = {
      url: this.getAPIUrl() + '/tranferData',
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }
}
